/**
 * @module Rum
 * @description
 */
import { useEffect, useState } from 'react';
import Script from 'next/script';
import { getAsset } from 'ui/js/utils/helpers';

export const RumScript = () => {
  const [isProdOrNonProd, setIsProdOrNonProd] = useState(false);
  const environment = process.env.environment === 'production' ? 'prod' : 'nonprod';

  useEffect( () => {
    const result = location.hostname === 'business.frontier.com' || location.hostname === 'qat02-business.frontier.com';
    setIsProdOrNonProd( result );
  }, [] );

  if( ! isProdOrNonProd ) {
    return null;
  }

  return (
    <Script
      src={ `${ getAsset( `/rv-assets/js/rum-${environment}.js` ) }` }
      strategy="afterInteractive"
    />
   );
}

RumScript.displayName = 'RumScript';

export default RumScript;
